(() => {
  const drawer = document.querySelector('[data-cart-drawer]');
  const itemsRoot = drawer?.querySelector('[data-cart-items]');
  if (!drawer || !itemsRoot) return;

  const root = window.Shopify?.routes?.root || '/';
  const route = path => `${root}${String(path).replace(/^\/+/, '')}`;
  let busy = false;

  const post = async (path, body) => {
    const response = await fetch(route(path), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    });
    if (!response.ok) throw new Error(`Cart request failed: ${response.status}`);
    return response.json();
  };

  const tierCode = quantity => {
    if (quantity === 2) return 'KYNORA2';
    if (quantity === 3) return 'KYNORA3';
    if (quantity > 3) return 'KYNORA4PLUS';
    return '';
  };

  itemsRoot.addEventListener('click', async event => {
    const button = event.target.closest('[data-bundle-quantity]');
    if (!button || busy) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    const target = Math.max(1, Number(button.dataset.bundleQuantity) || 1);
    const controls = button.closest('.cart-bundle__controls');
    const count = controls?.querySelector('b');
    const previous = Number(count?.textContent || 1);
    if (!controls || !count || target === previous) return;

    busy = true;
    controls.classList.add('is-syncing');
    count.textContent = String(target);
    controls.querySelectorAll('button').forEach(control => { control.disabled = true; });

    try {
      const cartResponse = await fetch(route('cart.js'), { headers: { Accept: 'application/json' } });
      if (!cartResponse.ok) throw new Error('Cart unavailable');
      const cart = await cartResponse.json();
      const supportItems = cart.items.filter(item => item.handle !== '90-day-extra-protection' && item.properties?._protection !== '90-day');
      const current = supportItems.reduce((sum, item) => sum + Number(item.quantity || 0), 0);
      if (!supportItems.length) throw new Error('No support item');

      if (target < current) {
        let remaining = target;
        const updates = {};
        supportItems.forEach(item => {
          const kept = Math.min(Number(item.quantity || 0), remaining);
          updates[item.key] = kept;
          remaining -= kept;
        });
        await post('cart/update.js', { updates, discount: tierCode(target) });
      } else if (target > current) {
        const first = supportItems[0];
        await post('cart/add.js', {
          items: [{
            id: first.variant_id,
            quantity: target - current,
            properties: first.properties || {}
          }]
        });
        await post('cart/update.js', { discount: tierCode(target) });
      }

      await window.KynoraCart?.refresh?.();
    } catch (error) {
      console.error('Fast cart quantity update failed:', error);
      count.textContent = String(previous);
      await window.KynoraCart?.refresh?.();
    } finally {
      busy = false;
      controls.classList.remove('is-syncing');
    }
  }, true);
})();
